<template>
  <div class="tabs_content" id="tab-2">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           :popup-message="getPopupMessage"
           @popup-action="_executePopupAction"
    />

    <PopupWithInput
        @submitAction="_executePopupWithInputAction"
    />

    <section>
      <a :data-title="$gettext('Přenačíst skupiny')" class="tab_button tab_button_refresh title_tooltip"
         @click.stop="_initChannelGroupsList"/>

      <div class="status"><h2 v-translate>Skupiny stanic</h2>
        <a
            v-if="isEditable"
            @click.stop="_createNewChannelGroup"
            :title="$gettext('Přidat skupinu stanic')"
            class="add add_expand"
            v-translate>Přidat skupinu stanic</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="devices-channel-groups">
          <table class="vypis vypis_detail parovaci_kody">
            <thead>
            <tr>
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <th><span class="name"><strong v-translate>Název</strong></span></th>
              <th><span v-translate>Typ skupiny</span></th>
              <th><span v-translate>Počet kanálů</span></th>
              <th><span v-translate>Uživatelský profil</span></th>
              <th><span v-translate>Témeatická skupina</span></th>
              <th><span v-translate>Přiřazená zařízení</span></th>
              <th><span v-translate>Upraveno</span></th>
              <th class="no_padding edit"/>
            </tr>
            </thead>
            <tbody>
            <ChannelGroupRow
                :devices="devices"
                :is-editable="isEditable"
                v-for="channelGroup in channelGroups"
                :channel-group="channelGroup"
              :key="channelGroup.idGroup"
                :selectedEntities="selectedEntities"
                @input="select"
                @resetChannelGroup="onResetChannelGroup"
                @removeChannelGroup="onRemoveChannelGroup"
                @duplicateChannelGroup="onDuplicateChannelGroup"
                @showChannelGroupDetail="showDeviceChannelGroupDetail(entity.id, arguments[0])"
            />
            </tbody>
          </table>
        </div>
      </div>
      <local-list-action-line
          :entities="channelGroups"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="devices-channel-groups"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import ChannelGroupRow from "./ChannelGroupRow";
import popup from "@/components/mixins/popup"
import popupWithInput from "@/components/mixins/popup-with-input"
import message from "@/components/mixins/message"
import Popup from "@/components/common/Popup"
import PopupWithInput from "../../../common/PopupWithInput";
import localTable from "@/components/mixins/local-table"
import links from "../../../mixins/links";

export default {
    name: "DeviceChannelGroups",
    components: {PopupWithInput, ChannelGroupRow, Popup},
    mixins: [popup, popupWithInput, message, localTable, links],
    props: {
        entity: Object,
        isEditable: Boolean
    },
    created(ChannelGroupService) {
        this.channelGroupService = ChannelGroupService;

        this._initChannelGroupsList();
    },
    data() {
        return {
            channelGroups: [],
            devices: {},
            isLoaded: false,
        }
    },
    computed:{
      entities(){
        return Object.values(this.channelGroups);
      },
      csvHeaders(){
        return {
          'name': {name: this.$gettext('Název')},
          'type': {name: this.$gettext('Typ skupiny'), callback: (entity) => {
              if (entity.type === "tv") {
                return this.$gettext("Televize");
              } else if (entity.type === "radio") {
                return this.$gettext("Rádia");
              } else {
                return this.$gettext("Uživatelská skupina");
              }
            }},
          'channel_count': {name: this.$gettext('Počet kanálů'), callback: (entity) => {return entity.channels.length}},
          'subscriber_profile_name': {name: this.$gettext('Uživatelský profil')},
          'thematic_group_name': {name: this.$gettext('Tématická skupina')},
          'devices': {name: this.$gettext('Přiřazená zařízení'), callback: (entity) => {
              if(entity.device_ids.length === 0){
                return this.$gettext("Všechna zařízení");
              }else{
                let deviceNames = [];
                for(const idDevice of entity.device_ids){
                  deviceNames.push(this.devices[idDevice]);
                }
                return deviceNames.join(', ');
              }
            }},
          'updated_timestamp': {name: this.$gettext('Upraveno'), callback: (entity) => {return entity.updated_timestamp ? this.$_datetime_format(entity.updated_timestamp) : ''}},
        }
      },
    },
    methods: {
        _initChannelGroupsList() {
            this.setLoadingMessage();
            this.isLoaded = false;
            this.channelGroups = [];

            return this.channelGroupService.getEntitiesByDeviceId(this.entity.id)
                .then((response) => {
                    this.emptyMessage();
                    this.channelGroups = response.channel_groups;
                    this.devices = response.devices;
                });
        },
        _createNewChannelGroup() {
            this.$router.push({
                name: 'createDeviceChannelGroup',
                params: {
                    idDevice: this.entity.id
                }
            });
        },
        onDuplicateChannelGroup(channelGroup) {
            let duplicatedName = channelGroup.name + ' (' + this.$gettext('kopie') + ')';

            this.showPopupWithInput("duplicate-channel-group", this.$gettext("Zadejte název nové duplikované skupiny:"), this.$gettext("Duplikovat"), duplicatedName, channelGroup);
        },
        onResetChannelGroup(id, showPopup = true) {
            if (showPopup) {
                this.showPopup(id, 'reset', 'reset-channel-group', null, this.$gettext('Opravdu si přejete resetovat skupinu kanálů?'));
            } else {
                this._removeChannelGroup(id);
            }
        },
        onRemoveChannelGroup(id, showPopup = true) {
            if (showPopup) {
                this.showPopup(id, 'delete', 'delete-channel-group');
            } else {
                this._removeChannelGroup(id);
            }
        },
        _removeChannelGroup(id) {
            this.setLoadingMessage();
            this.channelGroupService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                .then(() => {
                    this.setSuccessMessage();
                    return this._initChannelGroupsList();
                }).catch((error) => {
                    this.setErrorMessage(this._processDetailErrorMessage(error));
                });
        },
        _executePopupAction(value) {
            if (value) {
                switch(this.getPopupAction) {
                    case 'reset-channel-group':
                        this.onResetChannelGroup(this.getPopupId, false);
                    break;
                    case 'delete-channel-group':
                        this.onRemoveChannelGroup(this.getPopupId, false);
                    break;
                }
            }
            this.hidePopup();
        },
        _executePopupWithInputAction(action, inputValue, data) {
            if (action === 'duplicate-channel-group') {
                this._createDuplicatedChannelGroup(data, inputValue);
            }
        },
        _createDuplicatedChannelGroup(channelGroup, newChannelGroupName) {
            let newChannelGroup = {
                id_subscriber: this.entity.id_subscriber,
                name: newChannelGroupName,
                device_ids: [...channelGroup.device_ids],
                channel_ids: channelGroup.channels.map((channel) => channel.id)
            }

            this.createChannelGroup(newChannelGroup);
        },
        createChannelGroup(newChannelGroup) {
            this.setLoadingMessage();
            this.channelGroupService.createEntity(newChannelGroup).then(() => {
                this.setSuccessMessage();
                this._initChannelGroupsList();
            }).catch((error) => {
                this.setErrorMessage(this._processDetailErrorMessage(error));
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/ChannelGroups.vue